import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const BACKEND = BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "lch_admin_token";
export const CUSTOMER_TOKEN_KEY = "lch_customer_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public + customer-authenticated calls (separate token from admin).
export const publicApi = axios.create({ baseURL: API });
publicApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(CUSTOMER_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Build a full URL for a stored file reference.
export function fileUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND}${url}`;
}

// For private files served via <img> we append the token as a query param.
export function authFileUrl(url) {
  if (!url) return "";
  const full = fileUrl(url);
  if (url.startsWith("/api/files/") && !url.startsWith("/api/files/public")) {
    const token = localStorage.getItem(TOKEN_KEY);
    return `${full}?auth=${token}`;
  }
  return full;
}
